import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { injectIntl, defineMessages } from 'react-intl'
import { setUserInfo } from '../../common/users/actions'
import { compose } from 'recompose'
import { Logo, Button } from '../components'
import { roles } from '../../common/config'

/* TODO pure component */
class FirstListLearnPage extends React.Component {
  componentDidMount() {
    const { currentLesson, setUserInfo } = this.props
    if (currentLesson) {
      setUserInfo({ 
        userLanguage: currentLesson.baseLang,
        foreignLanguage: currentLesson.foreignLang,
        role: roles.USER,
      })
    }
  }

  render() {
    const { currentLesson, intl } = this.props

    if (!currentLesson) return null

    return (
      <div className="overlay-container vocabulary-learn-page-complete">
        <Logo size="large"/>
        <h3>{intl.formatMessage(messages.title)}</h3>
        {/*
        <Link to={`/vocabulary-learn/${currentLesson.id}`}>
          <Button big positive>
            {intl.formatMessage(messages.learn)}
          </Button>
        </Link>
        */}
        <p>{intl.formatMessage(messages.message)}</p>
        <Link to={`/sign-up-form`}>
          <Button big positive>
            {intl.formatMessage(messages.createBtn)}
          </Button>
        </Link>
      </div>
    )
  }
}

FirstListLearnPage.propTypes = {
  history: PropTypes.object.isRequired,
}

const enhance = compose(
  connect(state => ({
    currentLesson: state.lessons.currentLesson,
  }), { setUserInfo }),
  injectIntl,
)

export default enhance(FirstListLearnPage)


const messages = defineMessages({
  title: {
    id: 'firstListLearn.page.title',
    defaultMessage: 'Super zoznam :)',
  },
  message: {
    id: 'firstListLearn.page.message',
    defaultMessage: 'Vytvorte si účet pre uloženie a opakovanie slovíčok.',
  },
  learn: {
    id: 'firstListLearn.page.learn',
    defaultMessage: 'Precvičiť slovíčka',
  },
  createBtn: {
    id: 'firstListLearn.page.createBtn',
    defaultMessage: 'Vytvoriť účet',
  },
})




// WEBPACK FOOTER //
// ./src/browser/pages/FirstListLearnPage.js